var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.333 12.167v-.834h-2.5v-2.5h2.5V10.5H13v1.667h-.833v1.666H10.5V15.5H8.833V13H10.5v-.833h.833zM15.5 15.5h-3.333v-1.667h1.666v-1.666H15.5V15.5zM.5.5h6.667v6.667H.5V.5zm1.667 1.667V5.5H5.5V2.167H2.167zM8.833.5H15.5v6.667H8.833V.5zM10.5 2.167V5.5h3.333V2.167H10.5zM.5 8.833h6.667V15.5H.5V8.833zM2.167 10.5v3.333H5.5V10.5H2.167zM13 8.833h2.5V10.5H13V8.833zM3 3h1.667v1.667H3V3zm0 8.333h1.667V13H3v-1.667zM11.333 3H13v1.667h-1.667V3z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQr);
export default __webpack_public_path__ + "static/media/qr.fc9e828b03ac3cb891bcc054df3ff297.svg";
export { ForwardRef as ReactComponent };